import { ThemeConfig } from 'antd';

const antConfig: ThemeConfig = {
	token: {
		'blue-1': '#dee8fd',
		'blue-2': '#bed1fb',
		'blue-3': '#9dbbf9',
		'blue-4': '#7da4f7',
		'blue-5': '#5c8df5',
		'blue-6': '#4a71c4',
		'blue-7': '#375593',
		'blue-8': '#253862',
		'blue-9': '#121c31',
		'blue-10': '#090e19',
		'green-1': '#d7f5ec',
		'green-2': '#b0ebd9',
		'green-3': '#88e2c6',
		'green-4': '#61d8b3',
		'green-5': '#39cea0',
		'green-6': '#2ea580',
		'green-7': '#227c60',
		'green-8': '#175240',
		'green-9': '#0b2920',
		'green-10': '#061510',
		'magenta-1': '#ffd5e4',
		'magenta-2': '#feabc9',
		'magenta-3': '#fe80af',
		'magenta-4': '#fd5694',
		'magenta-5': '#fd2c79',
		'magenta-6': '#ca2361',
		'magenta-7': '#981a49',
		'magenta-8': '#651230',
		'magenta-9': '#330918',
		'magenta-10': '#19040c',
		colorText: '#1b1c21',
		colorTextSecondary: '#646e87',
		colorTextTertiary: '#c1c5cf',
		colorTextQuaternary: '#e0e2e7',
		'purple-1': '#efeffd',
		'purple-2': '#dedefa',
		'purple-3': '#bdbdf5',
		colorIcon: '#646e87',
		'purple-4': '#9d9df1',
		'purple-5': '#7c7cec',
		'purple-6': '#5b5be7',
		'purple-7': '#4949b9',
		colorBgMask: 'rgba(0.501960813999176, 0.5372549295425415, 0.6117647290229797, 0.7)',
		'purple-8': '#37378b',
		'purple-9': '#24245c',
		'purple-10': '#12122e',
		'red-1': '#ffeded',
		'red-2': '#ffdbdc',
		'red-3': '#ffb8b9',
		'red-4': '#ff9495',
		'red-5': '#ff7172',
		'red-6': '#ff4d4f',
		'red-7': '#cc3e3f',
		'red-8': '#992e2f',
		'red-9': '#661f20',
		'red-10': '#330f10',
		// "gray-1": "#e0e2e7",
		// "gray-2": "#c1c5cf",
		// "gray-3": "#a2a8b7",
		// "gray-4": "#838b9f",
		// "gray-5": "#646e87",
		// "gray-6": "#50586c",
		// "gray-7": "#3c4251",
		// "gray-8": "#282c36",
		// "gray-9": "#14161b",
		// "gray-10": "#0a0b0e",
		colorPrimary: '#5b5be7',
		controlOutline: 'rgba(0.3607843220233917, 0.3607843220233917, 0.9058823585510254, 0.1)',
		colorInfo: '#5b5be7',
	},
	components: {
		Input: {
			colorTextPlaceholder: '#c1c5cf',
			colorTextDisabled: '#c1c5cf',
			colorBorder: '#c1c5cf',
		},
		Tabs: {
			colorBorderSecondary: 'rgba(255, 14, 14, 0)',
			inkBarColor: 'rgb(239, 239, 253)',
			itemColor: 'rgba(100, 110, 135, 0.88)',
			itemActiveColor: 'rgb(91, 91, 231)',
			horizontalMargin: '0 0 0 0',
			horizontalItemGutter: 24,
		},
		Card: {
			headerBg: 'rgba(249, 250, 252, 1)',
		},
		Menu: {
			horizontalItemBorderRadius: 6,
			horizontalItemSelectedBg: '#EFEFFD',
			horizontalItemSelectedColor: '#5B5BE7',
			itemPaddingInline: 10,
			itemHeight: 28,
			activeBarHeight: 0,
			horizontalLineHeight: '28px',
			itemColor: '#646E87',
		},
		Table: {
			headerBg: 'transparent',
			headerColor: 'rgba(100, 110, 135, 1)',
		},
	},
};

export default antConfig;
